export const ProfilePage = () => {
  return (
    <section>
      <h2>Profil wird vorbereitet</h2>
      <p style={{ marginTop: '12px', color: '#3b4b66' }}>
        Bald kannst du hier deine persönlichen Daten, Spracheinstellungen und Benachrichtigungen verwalten.
      </p>
    </section>
  );
};
